import { render, staticRenderFns } from "./Flipcard.vue?vue&type=template&id=17a0464d&"
import script from "./Flipcard.vue?vue&type=script&lang=js&"
export * from "./Flipcard.vue?vue&type=script&lang=js&"
import style0 from "./Flipcard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports